import React from 'react'
import { useOktaAuth } from '@okta/okta-react'
import { FRONTEND_URL } from '../../constants/constants'

// Basic component with logout button
export function Logout() {
  const { oktaAuth } = useOktaAuth()
  const logout = async () => {
    await oktaAuth.signOut({
      clearTokensBeforeRedirect: true,
      postLogoutRedirectUri: `${FRONTEND_URL}`
    })
  }

  logout()

  return <h3 id="loading-icon">Login Out...</h3>
}
